import type { PaginationSetupData } from 'mmfintech-commons/types'
import { Pagination } from 'mmfintech-portal-commons'

interface Props {
  totalPages: number
  currentPage: number
  setCurrentPage: (data: PaginationSetupData) => void
  className?: string
  sort?: string
}

function CustomPagination({ totalPages, currentPage, setCurrentPage, className, sort }: Props) {
  function onPageChange(page: number) {
    setCurrentPage({ page, sort })
  }

  return (
    <Pagination
      marginPagesDisplayed={2}
      minPagesVisible={2}
      showPrevNextButtons={false}
      showPageLabel={true}
      totalPages={totalPages}
      currentPage={currentPage}
      setCurrentPage={onPageChange}
      className={className}
    />
  )
}

export default CustomPagination
